import { type DragEvent as ReactDragEvent, type ReactNode } from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import IcArrowRight from '@/assets/icons/ArrowRight.svg?react';
import styles from './StartSomethingNew.module.scss';

interface CardProps {
  to: string;
  title: string;
  subtitle: string;
  icon: ReactNode;
  state?: 'idle' | 'active' | 'rejected';
  onDragOver?: (e: ReactDragEvent<HTMLAnchorElement>) => void;
  onDrop?: (e: ReactDragEvent<HTMLAnchorElement>) => void;
}

const Card = ({
  to,
  title,
  subtitle,
  icon,
  state = 'idle',
  onDragOver,
  onDrop,
}: CardProps) => (
  <Link
    to={to}
    className={classNames(styles.card, {
      [styles.cardActive]: state === 'active',
      [styles.cardRejected]: state === 'rejected',
    })}
    onDragOver={onDragOver}
    onDrop={onDrop}
  >
    <span className={styles.iconWrap} aria-hidden="true">
      {icon}
    </span>
    <span className={styles.body}>
      <span className={styles.cardTitle}>{title}</span>
      <span className={styles.cardSubtitle}>{subtitle}</span>
    </span>
    <IcArrowRight className={styles.arrow} aria-hidden="true" />
  </Link>
);

export default Card;
